import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { tablaMultas } from '../../../../shared/data/tables/tabla-multas';
import { NgbdSortableHeader, SortEvent } from '../../../../shared/directives/NgbdSortableHeader';
import {  BehaviorSubject, forkJoin } from 'rxjs';
import { Component,HostListener,  OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { VehiclesService } from '../../../../shared/services/vehicles.service';
import { TarjetaOperacionService } from '../../../../shared/services/tarjeta-operaciones.service';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import { Utils } from '../../../../shared/utils/Utils';
const Swal = require("sweetalert2");

@Component({
  selector: 'app-inactivos',
  templateUrl: './inactivo.component.html',
  styleUrls: ['./inactivo.component.scss']
})
export class InactivoComponent implements OnInit {
  public selected = [];
  public filteredTableItem$: BehaviorSubject<tablaMultas[]> = new BehaviorSubject<tablaMultas[]>([]); // Nuevo BehaviorSubject para filtrar
  public searchText: string = ''; // Texto de búsqueda

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  isSelected = false;

  disabled = true;
  selectedEstado: any;
  vehicles: any[] = [];
  tarjetas: any;

  onNavChange1(changeEvent: NgbNavChangeEvent) {
    if (changeEvent.nextId === 5) {
      changeEvent.preventDefault();
    }
  }



  public show : boolean = false
  openDropdown: any = null; // Variable para controlar qué menú está abierto
  openDropdown2: any = null; // Variable para controlar qué menú está abierto
  sortColumn: string = '';
  sortDirection: string = 'asc'; // 'asc' o 'desc'
  searchTerm: string = '';
  dropdownStates: boolean[] = [];
  filteredTableItems!: VehiclesService[];
  

  constructor(
    private vehicleService: VehiclesService,
    private router: Router,

  
  ) {}

  ngOnInit() {
    this.selectedEstado="";
    this.listarInactivos();

    
  }

  
  pageSize1: number = 5; 
  page1: number = 1;
  totalItems!: number;

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    this.openDropdown = null;
    this.openDropdown2 = null;
  }

  
  stopPropagation(event: Event) {
    event.stopPropagation(); // Evita que el clic dentro del dropdown cierre el menú
  }
  // Función para ordenar las columnas
  onSort({ column, direction }: SortEvent) {
    // Restablecemos la dirección de orden de todas las columnas
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // Establecemos la columna y dirección de orden
   // this.service.sortColumn = column;
   // this.service.sortDirection = direction;
  }

  sortData(column: string) {
    if (this.sortColumn === column) {
      // Si ya estamos ordenando por esta columna, cambiar la dirección
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Si es una nueva columna, ordenar en orden ascendente
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.vehicles.sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];

      // Comparar los valores (ajusta la lógica según el tipo de dato)
      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
  }
  get filteredinfracciones() {
    if (!this.searchTerm) {
      return this.vehicles; // Mostrar todos los datos si no hay búsqueda
    }

    const term = this.searchTerm.toLowerCase();
    return this.vehicles.filter(Infraccion => {
      // Ajusta los campos por los que quieres buscar

    });
  }

  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) => (i === index ? !state : false));
  }


listarInactivos(): void {
  this.vehicleService.getInactiveVehicle().subscribe({
    next: (data) => {
      console.log(data);
      const vehicles = Array.isArray(data?.vehicles) ? data.vehicles : [];
      const estadoFechas = Array.isArray(data?.estadoFechas) ? data.estadoFechas : [];

      this.vehicles = vehicles.map((vehicle, index) => ({
        ...vehicle,
        estadoFechas: estadoFechas[index] || {}
      }));
      this.filteredTableItems = this.vehicles; // Importante para que el paginador funcione bien
    },
    error: (err) => {
      console.error("Error cargando vehículos inactivos", err);
      this.vehicles = [];
      this.filteredTableItems = [];
    }
  });
}

  
  
  
  
  estadoMap: { [key: string]: string } = {
    "VIGENTE": "badge badge-success",
    "POR VENCER": "badge badge-warning",
    "VENCIDO": "badge badge-secondary",
  };
  
  getEstadoColor(estado: string | undefined): string {
    return this.estadoMap[estado || ""] || "badge badge-light-primary"; // Si no hay estado, usa gris
  }

  

  
  
  
  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
 exportToPDF(tableId:string,nameFile:string,titleFile:string) {
  Utils.exportToPDF(tableId, nameFile,titleFile);
  }


  exportarExcel(tableId:string,nameFile:string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }
 
  avisoActivarPersona(placa: string) {
    Swal.fire({
      title: "ACTIVAR",
      text: `¿Desea activar el vehículo con placa: ${placa}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.vehicleService.activateVehicle(placa).subscribe({
          next: (response) => {
            Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: response.message,
              confirmButtonText: 'Aceptar'
            });
            this.listarInactivos(); // o this.listarActivos() si prefieres actualizar otra lista
          },
          error: (error) => {
            console.error('Error:', error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.error?.message || 'No se pudo activar el vehículo',
              confirmButtonText: 'Aceptar'
            });
          }
        });
      }
    });
  }
  
  
  
  
  

  editarPersona(placa:string){
     this.router.navigate(['/vehiculo/editar-vehiculo', placa]);
   }

   CrearVehiculo() {
    this.router.navigate(['/vehiculos/nuevos']);
  }
  

   cargarDocumentos(numero:string){
    this.router.navigate(['/digitales/digitales']);
  }

  filterData() {
    this.filteredTableItems = this.vehicles.filter((item) =>
      (item.placa)
        .toLowerCase()
        .includes(this.searchText.toLowerCase())
    );
  }


   ExportaHV(numero: string) {
    const doc = new jsPDF({
      orientation: "portrait", // Vertical
      unit: "mm",
      compress:true,
      format: "letter", // Tamaño carta (216 × 279 mm)
    });
  
    // Ruta de la imagen en assets
    const imgUrl = "../../../../../assets/images/hoja_vida/banner.jpg";
    const imgFoto = "../../../../../assets/images/hoja_vida/foto.png";
    
    // Convertir imagen en base64
    this.getBase64Image(imgFoto).then((fotoBase64) => {
    this.getBase64Image(imgUrl).then((imgData) => {
      doc.addImage(imgData, "JPG", 0, 0, 184, 270); // Agregar imagen al PDF
      doc.addImage(fotoBase64, "JPG", 20, 20, 40, 40); // (x, y, ancho, alto)
            
      // ✍️ Agregar el nombre debajo de la foto
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.setTextColor(255,255,255);
      doc.text('JOSÉ JORGE', 40, 70, { align: "center" });
      doc.text('ARRIETA NARVAEZ', 40, 76, { align: "center" });

      
      doc.roundedRect(2, 90, 75, 13, 1, 1, "F"); // Rectángulo redondeado
      // ✍️ Configurar el texto sobre el rectángulo
      doc.setFont("helvetica", "bold"); // Fuente en negrita
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0); // Color blanco
      doc.setFontSize(12);
       // 📌 Centrar el texto en el rectángulo
      const text = "ASESOR FINANCIERO";
      const textWidth = doc.getTextWidth(text); // Obtener ancho del texto
      const centerX = 2 + (75 / 2) - (textWidth / 2); // Centrado en X
      const centerY = 88 + (13 / 2) + 3; // Centrado en Y (ajustado)
      doc.text(text, centerX, centerY);
      
      doc.setFontSize(10);
      doc.setTextColor(255,255,255); // Color blanco
      doc.setFont("helvetica", "bold");
      doc.text('CC 1065579386' , 5, 110);
      doc.text('EXPEDIDA EN: VALLEDUPAR' , 5, 110+6);
      doc.text('FECHA NACIMIENTO: 28/03/1986' , 5, 110+12);
      doc.text('BARRANQUILLA - ATLANTICO' , 5, 110+18);
      doc.text('ESTADO CIVIL: CASADO' , 5, 110+24);


      doc.setTextColor(0, 0, 0); // Color blanco
      doc.roundedRect(2, 140, 75, 13, 1, 1, "F"); // Rectángulo redondeado
      // ✍️ Configurar el texto sobre el rectángulo
      doc.setFontSize(12);
      const text2 = "CONTACTO";
      const textWidth2 = doc.getTextWidth(text2); // Obtener ancho del texto
      const centerX2 = 2 + (75 / 2) - (textWidth2 / 2); // Centrado en X
      const centerY2 = 139 + (13 / 2) + 3; // Centrado en Y (ajustado)
      doc.text(text2, centerX2, centerY2);
      doc.setFontSize(10);
      doc.setTextColor(255,255,255);
      doc.text('CR 65C # 72-150 T1 1107' , 5, 160);
      doc.text('BELLO -  SAN GABRIEL',5,160+6);
      doc.text('+57 3135372913 - 604 5160047' , 5, 160+12);
      doc.text('jjarrieta@indesoftsas.com' , 5, 160+18);


      doc.setTextColor(0, 0, 0); // Color blanco
      doc.roundedRect(2, 190, 75, 13, 1, 1, "F"); // Rectángulo redondeado
      // ✍️ Configurar el texto sobre el rectángulo
      doc.setFontSize(12);
      const text3 = "LICENCIA DE CONDUCCIÓN";
      const textWidth3 = doc.getTextWidth(text3); // Obtener ancho del texto
      const centerX3 = 2 + (75 / 2) - (textWidth3 / 2); // Centrado en X
      const centerY3 = 188 + (13 / 2) + 3; // Centrado en Y (ajustado)
      doc.text(text3, centerX3, centerY3);
      doc.setFontSize(10);
      doc.setTextColor(255,255,255);
      doc.text('1065579386 - C2' , 5, 210);
      doc.text('31/12/2030' , 5, 216);
      doc.text('RH: 0+' , 5, 222);
    
     
      
  
   
   

      // 🔹 Encabezado "Experiencia Laboral"
      doc.setFillColor(115, 102, 255); // Color de fondo púrpura
      doc.roundedRect(85, 15, 115, 15, 3, 3, "F"); // Rectángulo redondeado
      doc.setFont("helvetica", "bold");
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(16);
      doc.text("EXPERIENCIA LABORAL", 140, 25, { align: "center" });
  
      // 📝 Información de Experiencia Laboral
      this.addExperience(doc, "EMPRESA XYZ", "ASESOR FINANCIERO", "36 MESES", "3135372913", 42);
      this.addExperience(doc, "EMPRESA ABC", "ANALISTA DE DATOS", "24 MESES", "3101234567", 68);
  
      // 🔹 Encabezado "Formación"
      doc.setFillColor(115, 102, 255);
      doc.roundedRect(85, 92, 115, 15, 3, 3, "F");
      doc.setFontSize(16);
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.text("FORMACIÓN ACADEMICA", 142, 101, { align: "center" });
  
      // 📌 Información Académica
      this.addEducation(doc, "UNIVERSIDAD XYZ", "TECNOLOGO", "PROGRAMADOR DE SOFTWARE", "2025", 118);
      this.addEducation(doc, "SENA ANTIOQUIA", "TECNICO", "PROGRAMADOR WEB", "2023", 145);
      
      doc.setFillColor(115, 102, 255); // Color de fondo púrpura
      doc.roundedRect(85, 175, 115, 15, 3, 3, "F"); // Rectángulo redondeado
      doc.setFont("helvetica", "bold");
      doc.setTextColor(255,255,255);
      doc.setFontSize(16);
      doc.text("CURSOS", 140, 185, { align: "center" });

      this.addCursos(doc, "SENA ANTIOQUIA", "CURSO TEORICO", "MANEJO DEFENSIVOS", "2025", 200);
      this.addCursos(doc, "SENA ANTIOQUIA", "CURSO TEORICO", "MANEJO DEFENSIVOS", "2025", 230);

      
     // doc.line(90, 245, 150,245); // Línea de separación
      // 🔥 Footer
      this.addFooter(doc);
  
      // 📄 Generar el PDF y abrir en nueva pestaña
      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
    })});
  }// 🔹 Función para agregar experiencia laboral
addExperience(doc: jsPDF, empresa: string, cargo: string, tiempo: string, telefono: string, y: number) {
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text(`EMPRESA: ${empresa}`, 90, y);
  doc.setFont("helvetica", "normal");
  doc.text(`CARGO: ${cargo}`, 90, y + 6);
  doc.text(`TIEMPO: ${tiempo}`, 90, y + 12);
  doc.text(`TELÉFONO: ${telefono}`, 90, y + 18);
}

// 🔹 Función para agregar educación
addEducation(doc: jsPDF, institucion: string, nivel: string, carrera: string, año: string, y: number) {
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text(institucion, 90, y);
  doc.setFont("helvetica", "normal");
  doc.text(nivel, 90, y + 6);
  doc.text(carrera, 90, y + 12);
  doc.text(año, 90, y + 18);
}

// 🔹 Función para agregar addCursos
addCursos(doc: jsPDF, institucion: string, nivel: string, carrera: string, año: string, y: number) {
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text(institucion, 90, y);
  doc.setFont("helvetica", "normal");
  doc.text(nivel, 90, y + 6);
  doc.text(carrera, 90, y + 12);
  doc.text(año, 90, y + 18);
}


// 🔹 Función para agregar footer correctamente
addFooter(doc: jsPDF) {
  const pageHeight = doc.internal.pageSize.height; // ✅ Obtener altura de la página correctamente
  doc.setFont("helvetica", "italic");
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text("Hoja de Vida - Generada by Admin SEAF - www.indesoftsas.com", 105, pageHeight - 8, { align: "center" });
}


   // Convertir imagen a Base64
   getBase64Image(imgUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imgUrl;
      img.crossOrigin = "Anonymous"; // Evita problemas de CORS

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png")); // Convertir a Base64
      };

      img.onerror = (error) => reject(error);
    });
  }

  
  

  
  
  
  
  
}